import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import Fab from '@mui/material/Fab';
import { Check } from '@mui/icons-material';
import { TipsOutline } from '@uplift/icons';
import { useToggleObject } from '../../../hooks/use-toggle';

import { useL10n } from '@uplift/hooks';


const useAvailabilityTipsStyles = makeStyles<{ position?: 'absolute' | 'fixed' }>()((theme, props) => ({
  root: {
    color: theme.palette.legacyPrimary.main,
    position: props.position ?? 'absolute',
    right: 0,
    bottom: 0,
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    zIndex: 10,
  },
  button: {
    backgroundColor: theme.palette.legacyPrimary.light,
    color: theme.palette.legacyPrimary.contrastText,
    marginBottom: theme.spacing(1),

    '&:hover': {
      backgroundColor: theme.palette.legacyPrimary.light,
    }
  },

  title: {
    fontWeight: 600,
  },

  listItemsWrapper: {
    fontWeight: 400,
  },

  paper: {
    backgroundColor: '#f0f4f4',
    color: theme.palette.common.black,
    boxShadow: theme.shadows[4]
  }
}));

export const AvailabilityTips: React.FC<{ position?: 'absolute' | 'fixed' }> = (props) => {
  const {
    value: open,
    close: handleClose,
    toggle: handleToggle
  } = useToggleObject(false);
  const { classes } = useAvailabilityTipsStyles({ position: props.position });
  const l10n = useL10n();
  const availabilityTips = l10n.calendar.availability.availabilityTips.tips;

  return (
    <Box {...props} className={classes.root}>
      <Tooltip
        open={open}
        onClose={handleClose}
        classes={{ tooltip: classes.paper }}
        title={(
          <Box px={2} py={1} maxWidth="322px">
            <Typography variant="body1" className={classes.title}>{l10n.calendar.availability.availabilityTips.title}</Typography>
            <Typography variant="body1" className={classes.listItemsWrapper}>
              <Box>
                {availabilityTips.map(item => (
                  <Box key={item} mt={2} display="flex" gap="8px">
                    <Check color="primary" />
                    {item}
                  </Box>
                )
                )}
              </Box>
            </Typography>
          </Box>
        )} placement="top-end"
      >
        <Fab className={classes.button} onClick={handleToggle}>
          <TipsOutline style={{ marginLeft: 6, marginTop: 2, fontSize: 30 }} />
        </Fab>
      </Tooltip>
      {l10n.calendar.availability.availabilityTips.buttonTitle}
    </Box>
  );
};
